/**
 * The draw canvas's em-box geometry, larger than the glyph anchor's on
 * mobile (40vh, capped at 280px). Shared by the live canvas, its
 * stroke-data placeholder and `DrawCanvasSkeleton`.
 */
export const DRAW_CANVAS_BOX =
    'aspect-square w-[min(40vh,280px)] md:size-[280px]'

// The canvas surface itself (shared with the landing's draw-beat specimen).
export const DRAW_CANVAS_SVG =
    'size-full cursor-crosshair touch-none rounded-sm border border-rule-soft text-ink'

// The verdict line under the canvas (shared with the landing's draw-beat
// specimen, which shows the accepted verdict).
export const DRAW_VERDICT_CLASS = 'font-serif text-sm text-body-fg'
